// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-card {
  width: auto;
  background-color: #FBF6FF;
}
.item-card {
  font-size: 36px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.item-card > .ant-card-head {
  color: #4A309D;
  background-color: #F4F4F4;
}
.item-card > div > div > div > span {
  white-space: pre;
}
.mr-5 {
  margin-right: 5px;
}
.item-card > .ant-card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}
.pie-card {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.pie-card > .ant-card-head {
  color: #4A309D;
  background-color: #F4F4F4;
}
.pie-card > .ant-card-body {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-grow: 1;
  padding: 5px;
}
.cate-card {
  display: flex;
  flex-direction: column;
}
.cate-card > .ant-card-head {
  color: #4A309D;
  background-color: #FBF6FF;
}
.cate-card > .ant-card-body {
  flex: 1 1;
  padding: 5px;
}
.header-text {
  font-size: 1em !important;
  font-weight: bold !important;
  text-align: center;
  color: #4A309D !important;
  margin-bottom: 0px !important;
}
.content-text {
  text-align: right !important;
  margin-bottom: 0 !important;
  font-size: 0.2em !important;
  opacity: 0.8;
  text-align: center;
  margin-top: 0 !important;
}
.card-head-text {
  font-size: 1em !important;
  text-align: left;
  color: #4A309D !important;
  margin: 0 !important;
}
.status-head-text {
  text-align: left;
  color: #4A309D !important;
  margin: 0 !important;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
.col-8 {
  grid-template-columns: repeat(8, 1fr);
}
.grid-container .col-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
.icon {
  font-size: 20px;
  line-height: 0;
}
.col-1 {
  display: flex;
  grid-area: 1 / 1 / 2 / 3;
}
.col-2 {
  display: flex;
  grid-area: 2 / 1 / 3 / 3;
}
.col-3 {
  grid-area: 1 / 3 / 3 / 6;
}
.col-4 {
  grid-area: 1 / 1 / 3 / 6;
}
.col-1-super {
  display: flex;
  grid-area: 1 / 1 / 2 / 6;
}
.col-2-super {
  grid-area: 2 / 1 / 2 / 6;
}
.col-1-admin {
  display: flex;
  grid-area: 1 / 1 / 2 / 3;
}
.col-2-admin {
  grid-area: 2 / 1 / 2 / 3;
}
.col-3-admin {
  grid-area: 1 / 3 / 3 / 6;
}
.col-4-admin {
  grid-area: 1 / 6 / 3 / 9;
}
@media (max-width: 575px) {
  .status-card > .ant-card-body {
    padding: 5px !important;
  }
  .status-card {
    font-size: 16px !important;
  }
  .status-card * > h2 {
    font-size: 16px !important;
  }
  .status-card * > h5 {
    font-size: 16px !important;
  }
  .card-head-text {
    font-size: 16px !important;
  }
}
@media (min-width: 576px) and (max-width: 992px) {
  .status-card {
    font-size: 12px !important;
  }
  .status-card * > h2 {
    font-size: 22px !important;
  }
  .status-card * > h5 {
    font-size: 14px !important;
  }
  .status-card > .ant-card-body {
    padding: 16px;
  }
}
@media (min-width: 993px) and (max-width: 1023.98px) {
  .status-card {
    font-size: 12px !important;
  }
  .status-card * > h2 {
    font-size: 12px !important;
  }
  .status-card * > h5 {
    font-size: 12px !important;
  }
  .card-head-text {
    font-size: 12px !important;
  }
  .item-card > .ant-card-body {
    padding: 10px;
  }
}
@media (min-width: 1024px) and (max-width: 1199.98px) {
  .status-card {
    font-size: 16px !important;
  }
  .status-card * > h2 {
    font-size: 16px !important;
  }
  .status-card * > h5 {
    font-size: 14px !important;
  }
  .card-head-text {
    font-size: 12px !important;
  }
  .item-card > .ant-card-body {
    padding: 5px;
  }
}
@media (min-width: 1200px) and (max-width: 1439.98px) {
  .status-card {
    font-size: 20px !important;
  }
  .status-card * > h2 {
    font-size: 1.5vw !important;
  }
  .status-card * > h5 {
    font-size: 16px !important;
  }
}
@media (min-width: 1440px) {
  .status-card {
    font-size: 26px !important;
  }
  .status-card * > h2 {
    font-size: 25px !important;
  }
  .status-card * > h5 {
    font-size: 16px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboard/style/StatusCard.less"],"names":[],"mappings":"AAMA;EACI,WAAA;EACA,yBAAA;AALJ;AAQA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AANJ;AASA;EACI,cAAA;EACA,yBAAA;AAPJ;AAUA;EACI,gBAAA;AARJ;AAWA;EACI,iBAAA;AATJ;AAYA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAVJ;AAcA;EACI,aAAA;EAEA,YAAA;EACA,sBAAA;AAbJ;AAgBA;EACI,cAAA;EACA,yBAAA;AAdJ;AAiBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAfJ;AAoBA;EACI,aAAA;EACA,sBAAA;AAlBJ;AAqBA;EACI,cAAA;EACA,yBAAA;AAnBJ;AAsBA;EACI,SAAA;EACA,YAAA;AApBJ;AAuBA;EACI,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;AArBJ;AAwBA;EACI,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AAtBJ;AAyBA;EACI,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AAvBJ;AA0BA;EACI,gBAAA;EACA,yBAAA;EACA,oBAAA;AAxBJ;AA2BA;EACI,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;AAzBJ;AA4BA;EACI,qCAAA;AA1BJ;AA6BA;EACI,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;AA3BJ;AA+BA;EACI,eAAA;EACA,cAAA;AA7BJ;AAgCA;EAEI,aAAA;EACA,wBAAA;AA/BJ;AAkCA;EACI,aAAA;EACA,wBAAA;AAhCJ;AAmCA;EACI,wBAAA;AAjCJ;AAoCA;EACI,wBAAA;AAlCJ;AAsCA;EACI,aAAA;EACA,wBAAA;AApCJ;AAwCA;EACI,wBAAA;AAtCJ;AA0CA;EACI,aAAA;EACA,wBAAA;AAxCJ;AA2CA;EACI,wBAAA;AAzCJ;AA4CA;EAEI,wBAAA;AA3CJ;AA+CA;EAEI,wBAAA;AA9CJ;AAiDA;EACI;IACI,uBAAA;EA/CN;EAkDE;IACI,0BAAA;EAhDN;EAmDE;IACI,0BAAA;EAjDN;EAoDE;IACI,0BAAA;EAlDN;EAqDE;IACI,0BAAA;EAnDN;AACF;AAsDA;EACI;IACI,0BAAA;EApDN;EAuDE;IACI,0BAAA;EArDN;EAwDE;IACI,0BAAA;EAtDN;EAyDE;IACI,aAAA;EAvDN;AACF;AA0DA;EACI;IACI,0BAAA;EAxDN;EA2DE;IACI,0BAAA;EAzDN;EA4DE;IACI,0BAAA;EA1DN;EA6DE;IACI,0BAAA;EA3DN;EA8DE;IACI,aAAA;EA5DN;AACF;AA+DA;EACI;IACI,0BAAA;EA7DN;EAgEE;IACI,0BAAA;EA9DN;EAiEE;IACI,0BAAA;EA/DN;EAkEE;IACI,0BAAA;EAhEN;EAmEE;IACI,YAAA;EAjEN;AACF;AAoEA;EACI;IACI,0BAAA;EAlEN;EAqEE;IAEI,2BAAA;EApEN;EAuEE;IACI,0BAAA;EArEN;AACF;AAwEA;EACI;IACI,0BAAA;EAtEN;EAyEE;IACI,0BAAA;EAvEN;EA0EE;IACI,0BAAA;EAxEN;AACF","sourcesContent":["// variable\n@cardBackground: #FBF6FF;\n@textColor: #4A309D;\n@backgroundColor: #F4F4F4;\n\n//element class\n.status-card {\n    width: auto;\n    background-color: @cardBackground;\n}\n\n.item-card {\n    font-size: 36px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.item-card>.ant-card-head {\n    color: @textColor;\n    background-color: @backgroundColor;\n}\n\n.item-card>div>div>div>span {\n    white-space: pre;\n}\n\n.mr-5 {\n    margin-right: 5px;\n}\n\n.item-card>.ant-card-body {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex-grow: 1;\n    // padding: 5px 5px 0px 5px;\n}\n\n.pie-card {\n    display: flex;\n    // width: 100%;\n    height: 100%;\n    flex-direction: column;\n}\n\n.pie-card>.ant-card-head {\n    color: @textColor;\n    background-color: @backgroundColor;\n}\n\n.pie-card>.ant-card-body {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-grow: 1;\n    padding: 5px;\n    // padding: 5px 5px 0px 5px;\n}\n\n//use on admin side\n.cate-card {\n    display: flex;\n    flex-direction: column;\n}\n\n.cate-card>.ant-card-head {\n    color: @textColor;\n    background-color: @cardBackground;\n}\n\n.cate-card>.ant-card-body {\n    flex: 1;\n    padding: 5px;\n}\n\n.header-text {\n    font-size: 1em !important;\n    font-weight: bold !important;\n    text-align: center;\n    color: @textColor !important;\n    margin-bottom: 0px !important;\n}\n\n.content-text {\n    text-align: right !important;\n    margin-bottom: 0 !important;\n    font-size: 0.2em !important;\n    opacity: 0.8;\n    text-align: center;\n    margin-top: 0 !important;\n}\n\n.card-head-text {\n    font-size: 1em !important;\n    text-align: left;\n    color: @textColor !important;\n    margin: 0 !important;\n}\n\n.status-head-text {\n    text-align: left;\n    color: @textColor !important;\n    margin: 0 !important;\n}\n\n.grid-container {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-template-rows: repeat(2, 1fr);\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n}\n\n.col-8 {\n    grid-template-columns: repeat(8, 1fr);\n}\n\n.grid-container .col-5 {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-template-rows: repeat(2, 1fr);\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n}\n\n\n.icon {\n    font-size: 20px;\n    line-height: 0;\n}\n\n.col-1 {\n    // row start / col start / row end / col end\n    display: flex;\n    grid-area: 1 / 1 / 2 / 3;\n}\n\n.col-2 {\n    display: flex;\n    grid-area: 2 / 1 / 3 / 3;\n}\n\n.col-3 {\n    grid-area: 1 / 3 / 3 / 6;\n}\n\n.col-4 {\n    grid-area: 1 / 1 / 3 / 6;\n\n}\n\n.col-1-super {\n    display: flex;\n    grid-area: 1 / 1 / 2 / 6;\n\n}\n\n.col-2-super {\n    grid-area: 2 / 1 / 2 / 6;\n}\n\n\n.col-1-admin {\n    display: flex;\n    grid-area: 1 / 1 / 2 / 3;\n}\n\n.col-2-admin {\n    grid-area: 2 / 1 / 2 / 3;\n}\n\n.col-3-admin {\n\n    grid-area: 1 / 3 / 3 / 6;\n\n}\n\n.col-4-admin {\n\n    grid-area: 1 / 6 / 3 / 9;\n}\n\n@media (max-width: 575px) {\n    .status-card>.ant-card-body {\n        padding: 5px !important;\n    }\n\n    .status-card {\n        font-size: 16px !important;\n    }\n\n    .status-card *>h2 {\n        font-size: 16px !important;\n    }\n\n    .status-card *>h5 {\n        font-size: 16px !important;\n    }\n\n    .card-head-text {\n        font-size: 16px !important;\n    }\n}\n\n@media (min-width:576px) and (max-width: 992px) {\n    .status-card {\n        font-size: 12px !important;\n    }\n\n    .status-card *>h2 {\n        font-size: 22px !important;\n    }\n\n    .status-card *>h5 {\n        font-size: 14px !important;\n    }\n\n    .status-card>.ant-card-body {\n        padding: 16px;\n    }\n}\n\n@media (min-width:993px) and (max-width: 1023.98px) {\n    .status-card {\n        font-size: 12px !important;\n    }\n\n    .status-card *>h2 {\n        font-size: 12px !important;\n    }\n\n    .status-card *>h5 {\n        font-size: 12px !important;\n    }\n\n    .card-head-text {\n        font-size: 12px !important;\n    }\n\n    .item-card>.ant-card-body {\n        padding: 10px;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1199.98px) {\n    .status-card {\n        font-size: 16px !important;\n    }\n\n    .status-card *>h2 {\n        font-size: 16px !important;\n    }\n\n    .status-card *>h5 {\n        font-size: 14px !important;\n    }\n\n    .card-head-text {\n        font-size: 12px !important;\n    }\n\n    .item-card>.ant-card-body {\n        padding: 5px;\n    }\n}\n\n@media (min-width: 1200px) and (max-width: 1439.98px) {\n    .status-card {\n        font-size: 20px !important;\n    }\n\n    .status-card *>h2 {\n        // font-size: 20px !important;\n        font-size: 1.5vw !important;\n    }\n\n    .status-card *>h5 {\n        font-size: 16px !important;\n    }\n}\n\n@media (min-width: 1440px) {\n    .status-card {\n        font-size: 26px !important;\n    }\n\n    .status-card *>h2 {\n        font-size: 25px !important;\n    }\n\n    .status-card *>h5 {\n        font-size: 16px !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
